<template>
    <v-container fluid class="root-step-container">
        <h2 class="text-h5 mb-4">{{ $t("risk-aversion.form2.title") }}</h2>
        <EqsRadio
            :value.sync="formData.p2q1"
            row
            v-bind="{
                label: $t('risk-aversion.form2.q1-label'),
                ...schemaDouble.p2q1
            }"
        />
        <div v-show="formData.p2q1 === 'yes'" class="pa-0 ma-0">
            <EqsSelect
                :value.sync="formData.p2q2"
                multiple
                v-bind="{
                    label: $t('risk-aversion.form2.q2-label'),
                    items: q2Items,
                    ...schemaDouble.p2q2
                }"
            />
        </div>
        <EqsSelect
            :value.sync="formData.p2q3"
            v-bind="{
                label: $t('risk-aversion.form2.q3-label'),
                items: q3Items,
                ...schemaDouble.p2q3
            }"
        />
        <EqsSelect
            :value.sync="formData.p2q4"
            v-bind="{
                label: $t('risk-aversion.form2.q4-label'),
                items: q4Items,
                ...schemaDouble.p2q4
            }"
        />
        <EqsSelect
            :value.sync="formData.p2q5"
            v-bind="{
                label: $t('risk-aversion.form2.q5-label'),
                items: q5Items,
                ...schemaDouble.p2q5
            }"
        />
        <EqsRadio
            :value.sync="formData.p2q6"
            row
            v-bind="{
                label: $t('risk-aversion.form2.q6-label'),
                ...schemaDouble.p2q6
            }"
        />
        <div v-show="formData.p2q6 === 'yes'" class="pa-0 ma-0">
            <EqsNumber
                :value.sync="formData.p2q7"
                :is-currency="false"
                :is-percentage="true"
                v-bind="{
                    label: $t('risk-aversion.form2.q7-label'),
                    editable: true,
                    placeholder: 'Ex: 5%',
                    ...schemaDouble.p2q7
                }"
            />
        </div>
        <div v-show="formData.p2q6 === 'yes'" class="pa-0 ma-0">
            <EqsNumber
                :value.sync="formData.p2q8"
                :is-currency="false"
                :is-percentage="true"
                v-bind="{
                    label: $t('risk-aversion.form2.q8-label'),
                    editable: true,
                    placeholder: 'Ex: 10%',
                    ...schemaDouble.p2q8
                }"
            />
        </div>
        <div v-show="formData.p2q6 === 'yes'" class="pa-0 ma-0">
            <EqsNumber
                :value.sync="formData.p2q9"
                :is-currency="false"
                :is-float="false"
                v-bind="{
                    label: $t('risk-aversion.form2.q9-label'),
                    editable: true,
                    placeholder: 'Ex: 100 000',
                    ...schemaDouble.p2q9
                }"
            />
        </div>
        <EqsSelect
            :value.sync="formData.p2q10"
            v-bind="{
                label: $t('risk-aversion.form2.q10-label'),
                items: q10Items,
                ...schemaDouble.p2q10
            }"
        />
    </v-container>
</template>

<script>
import { formMixin } from "@equisafe-ui-vue/src/mixins/formMixin";

export default {
    name: "Form2",
    mixins: [formMixin],
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {};
    },
    computed: {
        q2Items() {
            return [
                { text: this.$t("risk-aversion.form2.q2-items.short-term"), value: "Court terme" },
                { text: this.$t("risk-aversion.form2.q2-items.medium-term"), value: "Moyen terme" },
                { text: this.$t("risk-aversion.form2.q2-items.long-term"), value: "Long terme" }
            ];
        },
        q3Items() {
            return [
                { text: this.$t("risk-aversion.form2.q3-items.zero"), value: "0%" },
                { text: this.$t("risk-aversion.form2.q3-items.less-than-50"), value: "Moins de 50%" },
                { text: this.$t("risk-aversion.form2.q3-items.hundred"), value: "100%" }
            ];
        },
        q4Items() {
            return [
                { text: this.$t("risk-aversion.form2.q4-items.salary"), value: "Salaire" },
                { text: this.$t("risk-aversion.form2.q4-items.retirement"), value: "Retraite" },
                { text: this.$t("risk-aversion.form2.q4-items.inheritance"), value: "Héritage" },
                { text: this.$t("risk-aversion.form2.q4-items.investments"), value: "Investissements" }
            ];
        },
        q5Items() {
            return [
                { text: this.$t("risk-aversion.form2.q5-items.diversify"), value: "Diversier mon portefeuille" },
                { text: this.$t("risk-aversion.form2.q5-items.finance-projects"), value: "Financer des projets qui m'impactent" },
                { text: this.$t("risk-aversion.form2.q5-items.grow-savings"), value: "Faire fructifier mon épargne" },
                { text: this.$t("risk-aversion.form2.q5-items.economic-growth"), value: "Etre acteur de la croissance économique" }
            ];
        },
        q10Items() {
            return [
                { text: this.$t("risk-aversion.form2.q10-items.less-than-1-year"), value: "Moins de 1 an" },
                { text: this.$t("risk-aversion.form2.q10-items.1-to-5-years"), value: "Entre 1 an et 5 ans" },
                { text: this.$t("risk-aversion.form2.q10-items.more-than-5-years"), value: "Plus de 5 ans" }
            ];
        }
    },
    watch: {
        "formData.p2q1": {
            handler(newVal, oldVal) {
                this.schemaDouble.p2q2.isRequired = newVal === "yes";
            },
            immediate: true
        },
        "formData.p2q6": {
            handler(newVal, oldVal) {
                this.schemaDouble.p2q7.isRequired = newVal === "yes";
                this.schemaDouble.p2q8.isRequired = newVal === "yes";
                this.schemaDouble.p2q9.isRequired = newVal === "yes";
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
